/** Lifetime of reads started by the current authenticated workspace. */
let controller = new AbortController();

export function workspaceReadSignal(): AbortSignal {
  return controller.signal;
}

/** Cancel SDK/worker results even when the same account signs back in. */
export function resetWorkspaceReadSession(): void {
  controller.abort();
  controller = new AbortController();
}
